import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DashboardContainer from '../containers/Dashboard';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FMPSectionCard from '../components/ui/FMPSectionCard';

// icons
import AdjustIcon from "../images/externalLogisticsIcons/adjust.svg";
// import BlueTruck from "../images/externalLogisticsIcons/blueTruck.svg";
// import EcoFuel from "../images/externalLogisticsIcons/ecoFuel.svg";
// import Factory from "../images/externalLogisticsIcons/factory.svg";
import GasPump from "../images/externalLogisticsIcons/gasPump.svg";
import Bookmark from "../images/externalLogisticsIcons/bookMark.svg";
import Monitoring from "../images/externalLogisticsIcons/monitoring.svg";
import Search from "../images/externalLogisticsIcons/search.svg";
// import Train from "../images/externalLogisticsIcons/train.svg";
import Truck from "../images/externalLogisticsIcons/truck.svg";
import AuthUserContainer from '../containers/AuthUser';

const styles = (theme) => {
	return {
		root: {
			width: '100%',
			height: 'auto',
			zIndex: 1,
			overflow: 'hidden',
			backgroundColor: '#e5e5e6'
		},
		panel: {
			marginTop: 30,
		},
		emptyPanel: {
			minHeight: 270,
			fontWeight: 100,
			color: '#aaa',
			fontSize: 30,
			marginTop: 30,
		},
		innerPaper: {
			padding: 10,
			paddingTop: 5,
			textAlign: 'left',
			fontSize: 14,
			[theme.breakpoints.up('md')]: {
				padding: 40,
				paddingTop: 30,
			}
		},
		lastFtpCheck: {
			//marginTop : 20,
			//color : "#888"
		},
		ftpSection: {
			lineHeight: 1.6,
			marginTop: 10,
		},
		title: {
			textTransform: 'uppercase',
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
			marginBottom: 5,
		},
		label: {
		},

		labelDate: {
			fontSize: 12,
			fontWeight: 100,
			color: '#999',
		},
		value: {
			fontWeight: 600,
		},
		statusIcon: {
			position: 'absolute',
			right: 0,
		},
		ftpWarning: {
			color: '#FFC107',
		},
		ftpGood: {
			color: '#4CAF50',
		},
		ftpStatusIcon: {
			width: 14,
			height: 14,
			verticalAlign: 'middle',
			paddingLeft: 5,
		},
		ftpStatusIconLarge: {
			width: 32,
			height: 32,
			verticalAlign: 'middle',
		},
		dataSection: {
			marginTop: 25,
			lineHeight: 1.6,
		},
		dgsButton: {
			position: 'relative',
			right: 0,
			borderRadius: 100
		},
		dgsButtonContainer: {
			display: 'flex',
			justifyContent: 'flex-end',
			marginTop: 30,
		},
		tableRow: {
			fontWeight: 400,
		},
		row: {
			margin: 0,
			width: '100%',
			backgroundColor: '#fff'
		},
		oddRow: {
			margin: 0,
			width: '100%',
			backgroundColor: '#eee'
		},
		masthead: {
			textAlign: 'left',
			fontSize: 24,
			color: '#666',
			letterSpacing: 0,
			textTransform: 'uppercase',
			fontWeight: 300,
			marginBottom: 15,
			marginTop: 15,
			//margin: '2px 0px 5px 0px',
			position: 'relative',
			marginLeft: 0,

			[theme.breakpoints.up('sm')]: {
				fontWeight: 300,
				fontSize: 22,
				//margin: '10px 0px 10px 0px',
			},
			[theme.breakpoints.up('md')]: {
				fontSize: 30,
				//margin: '10px 0px 10px 0px',
			},
		},
		subMasthead: {
			textAlign: 'left',
			fontSize: 18,
			color: '#666',
			letterSpacing: 0,
			textTransform: 'uppercase',
			fontWeight: 300,
			marginBottom: 10,
			marginTop: 15,
			//margin: '2px 0px 5px 0px',
			position: 'relative',
			marginLeft: 0,
		}
	};
};

class ExternalLogisticsDashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		const { classes } = this.props;

		return (<>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<div className={classes.masthead}>Welcome to the Fuel Management Platform (FMP)</div>
				</Grid>

				<Grid item xs={12}>
					<div className={classes.subMasthead}>
						Logistics Tools
					</div>
				</Grid>
				<Grid item xs={12} sm={6}>
					<FMPSectionCard
						title={'Tank Monitoring'}
						icon={Monitoring}
						description={
							`See a listing of every monitored tank in the system, previous delivery, 
							next delivery, and estimated delivery.
							Single click to schedule a new delivery for a station.
							`}
						url={'/logistics/monitoring'}
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					<FMPSectionCard
						title={'Inventory Volumes'}
						icon={AdjustIcon}
						description={`Add, update, and view all the tank volume levels for the past 
						20 days along with the sales volume for that day. `}
						url={'/logistics/inventory'}
					/>
				</Grid>


				<Grid item xs={12} sm={6}>
					<FMPSectionCard
						title={'Station Deliveries'}
						icon={Truck}
						description={`Add, update, and view a listing of all upcoming and past station deliveries 
							for the past 45 days. Each station can be drilled down into for more details and updates.`}
						url={'/logistics/deliveries'}
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					<FMPSectionCard
						title={'Delivery Search'}
						icon={Search}
						description={`Run advanced searches based on carriers, pickup suppliers, 
						pickup terminals and loading numbers for station deliveries. 
						Searches can be saved across page reloads to quickly run past searches.`}
						url={'/logistics/deliverySearch'}
					/>
				</Grid>

				<Grid item xs={12}>
					<div className={classes.subMasthead}>
						Additional Logistics Info
					</div>
				</Grid>

				<Grid item xs={12} sm={6}>
					<FMPSectionCard
						title={'Station Listing'}
						icon={GasPump}
						description={`Quickly view all stations currently serviced by Pearson Fuels.`}
						url={'/stations'}
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					<FMPSectionCard
						title={'Activity Log'}
						icon={Bookmark}
						description={`Review all station delivery activity on your user account to quickly
								review all modifications made over a given time period.`}
						url={'/logistics/activityLogSearch'}
					/>
				</Grid>

				{/*
				<Grid item xs={12} sm={6}>
					<FMPSectionCard
						title={'Carrier Listing'}
						icon={BlueTruck}
						description={`Full listing of all carriers along with contact information that
						Person Fuels does business with.`}
						url={'/logistics/carriers'}
					/>
				</Grid>


				<Grid item xs={12} sm={6}>
					<FMPSectionCard
						title={'Fuel Vendors and Suppliers'}
						icon={EcoFuel}
						description={`Full listing of all suppliers along with contact information that
						Pearson Fuels does business with.`}
						url={'/logistics/suppliers'}
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					<FMPSectionCard
						title={'Terminal Listing'}
						icon={Factory}
						description={`Full terminal listing, contact information and which suppliers and
						 products are distributed out of those terminals.`}
						url={'/logistics/terminals'}
					/>
				</Grid>
				*/}

			</Grid>
		</>);
	}
}

ExternalLogisticsDashboard.propTypes = {
	classes: PropTypes.object.isRequired,
	userMap: PropTypes.object,
	authUser: PropTypes.object,
	isExternalLogistics: PropTypes.bool,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	DashboardContainer,
])(ExternalLogisticsDashboard);

